export const getImageQuery = (width: number, height: number, fit: string = 'clip', key: string = 'image') => (`
    ${key} {
        width
        height
        url(transformation: {
          image: { resize: { width: ${width}, height: ${height}, fit: ${fit} } }
        }) 
    }
`);
